import { useMemo } from 'react';

import { DensityType, IframeTypes } from '@cashier/cashier-model';

import { useCashierConfiguration } from '../../../../../../../hooks';

const getDensity = (labelPosition: 'default' | 'inline'): DensityType => {
  if (labelPosition === 'default') {
    return 'comfortable';
  }

  return 'compact';
};

export const useIframeSrc = (
  fieldName: string,
  labelPosition: 'default' | 'inline',
) => {
  const { direction, platform, theme, cashierFieldUrl } =
    useCashierConfiguration();

  return useMemo(() => {
    const baseUrl = `${cashierFieldUrl}/${IframeTypes.Field}`;
    const params = new URLSearchParams();

    params.set('field', fieldName);
    params.set('host', globalThis.location.origin);
    params.set('direction', direction.toString());
    params.set('platform', platform);
    params.set('theme', theme.toString());
    params.set('density', getDensity(labelPosition));

    return `${baseUrl}?${params.toString()}`;
  }, [cashierFieldUrl, fieldName, direction, platform, theme, labelPosition]);
};
